'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./context-menu.scss');

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _withDevice = require('../with-device/with-device');

var _withDevice2 = _interopRequireDefault(_withDevice);

require('./context-menu-list.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var animationStates = {
  open: 'open',
  close: 'close'
};

var ANIMATION_DURATION = 400;
var BASE_SPACE_FROM_WINDOW_END = '20px';

var ContextMenuList = function (_React$Component) {
  _inherits(ContextMenuList, _React$Component);

  function ContextMenuList(props) {
    _classCallCheck(this, ContextMenuList);

    var _this = _possibleConstructorReturn(this, (ContextMenuList.__proto__ || Object.getPrototypeOf(ContextMenuList)).call(this, props));

    _this.timeout = null;
    _this.state = { animation: animationStates.close };

    _this.triggerClose = _this.triggerClose.bind(_this);
    return _this;
  }

  _createClass(ContextMenuList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setPosition();

      // eslint-disable-next-line
      this.setState({
        animation: animationStates.open
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.setPosition();
    }
  }, {
    key: 'setPosition',
    value: function setPosition() {
      var _props = this.props,
          device = _props.device,
          verticalDock = _props.verticalDock,
          horizontalDock = _props.horizontalDock,
          position = _props.position;

      var menuHeight = this.listRef.offsetHeight;

      if (device.isPhone) {
        this.listRef.style = null;
        return;
      }

      if (horizontalDock === 'left') {
        this.listRef.style.left = position.left;
      } else {
        this.listRef.style.right = position.right;
      }

      if (verticalDock === 'top') {
        var hasEnoughSpaceOnScreen = window.innerHeight - (menuHeight + parseInt(position.top, 10)) > 0;

        if (hasEnoughSpaceOnScreen) {
          this.listRef.style.top = position.top;
        } else {
          this.listRef.style.bottom = BASE_SPACE_FROM_WINDOW_END;
        }
      }

      if (verticalDock === 'bottom') {
        var _hasEnoughSpaceOnScreen = window.innerHeight - (menuHeight + parseInt(position.bottom, 10)) > 0;

        if (_hasEnoughSpaceOnScreen) {
          this.listRef.style.bottom = position.bottom;
        } else {
          this.listRef.style.top = BASE_SPACE_FROM_WINDOW_END;
        }
      }
    }
  }, {
    key: 'triggerClose',
    value: function triggerClose(event) {
      event.preventDefault();
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();

      var _props2 = this.props,
          device = _props2.device,
          onClose = _props2.onClose;


      if (device.isPhone) {
        if (this.state.animation === animationStates.close) {
          // Can be triggered multiple times on mobile, because of the closing animation
          return;
        }

        this.setState({
          animation: animationStates.close
        }, function () {
          setTimeout(function () {
            onClose();
          }, ANIMATION_DURATION);
        });
      } else {
        // desktop
        onClose();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          className = _props3.className,
          children = _props3.children,
          device = _props3.device;
      var animation = this.state.animation;
      var isPhone = device.isPhone;


      var wrapperClasses = (0, _classnames2.default)('context-menu-list-wrapper', isPhone && 'context-menu-list-wrapper--mobile', isPhone && animation && 'context-menu-list-wrapper--' + animation);

      var classes = (0, _classnames2.default)('context-menu-list', isPhone && 'context-menu-list--mobile', isPhone && animation && 'context-menu-list--' + animation, className);

      return _react2.default.createElement(
        'div',
        { className: wrapperClasses, onClick: this.triggerClose, onContextMenu: this.triggerClose },
        _react2.default.createElement(
          'ul',
          {
            className: classes,
            ref: function ref(listRef) {
              _this2.listRef = listRef;
            }
          },
          children
        )
      );
    }
  }]);

  return ContextMenuList;
}(_react2.default.Component);

ContextMenuList.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  device: _propTypes2.default.shape({
    isPhone: _propTypes2.default.bool.isRequired
  }).isRequired,
  horizontalDock: _propTypes2.default.oneOf(['left', 'right']),
  onClose: _propTypes2.default.func,
  position: _propTypes2.default.shape({
    top: _propTypes2.default.string.isRequired,
    right: _propTypes2.default.string.isRequired,
    bottom: _propTypes2.default.string.isRequired,
    left: _propTypes2.default.string.isRequired
  }).isRequired,
  verticalDock: _propTypes2.default.oneOf(['top', 'bottom'])
};

ContextMenuList.defaultProps = {
  horizontalDock: 'left',
  onClose: function onClose() {
    return null;
  },
  verticalDock: 'top'
};

exports.default = (0, _withDevice2.default)(ContextMenuList);